import { param } from "jquery";
import { sendMessage } from "../../../config/utils/message";
import { CORE_API_AKADEMIK } from "../../key/api";

const user = localStorage.getItem("nama");

export async function getJenis() {
  try {
    const response = await CORE_API_AKADEMIK.get("dropdown/jenis/evaluasi");
    return response;
  } catch (err) {
    return false;
  }
}

export async function getViewEval(data) {
  try {
    const response = await CORE_API_AKADEMIK.get("evaluasi/mahasiswa/input", {
      params: data,
    });
    return response;
  } catch (err) {
    sendMessage(500);
  }
}

export async function getTahunAjaran(id) {
  try {
    const response = await CORE_API_AKADEMIK.get("dropdown/ajaran");
    return response;
  } catch (err) {
    return false;
  }
}

export async function postEval(data, id) {
  try {
    const response = await CORE_API_AKADEMIK.post(
      "evaluasi/mahasiswa/input?idjenis=" + id,
      data
    );
    return response;
  } catch (err) {
    return false;
  }
}

export async function validasiEvaluasi(nim, ta, smtta, kurikulum) {
  try {
    const response = await CORE_API_AKADEMIK.get(
      `validasi/evaluasi?nim=${nim}&ta=${ta}&smtta=${smtta}&kurikulum=${kurikulum}`
    );
    return response;
  } catch (error) {
    console.error("Error during validasiEvaluasi:", error);
    throw error;
  }
}

